'use client';

import { Background, Parallax } from 'react-parallax';

import type { FC } from 'react';
import type { BackgroundProps, ParallaxProps } from 'react-parallax';

export type ParallaxBackgroundProps =
  & Omit<ParallaxProps, 'title' | 'image'>
  & BackgroundProps;

export const ParallaxBackground: FC<ParallaxBackgroundProps> = ({
  children,
  className,
  ...props
}) => (
  <Parallax {...props}>
    <Background className={className}>
      {children}
    </Background>
  </Parallax>
);
